




























































































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import FabricFilter from "./FabricFilter.vue";
import FabricService from "@/services/fabric_service";
import * as fabric from "@/models/products/fabric";
import { ProductType } from "@/models/products/product";
import Swatch from "@/components/elements/products/Swatch.vue";
import { FabricComponent } from "@/models/configurator/fabric_components";
import { APIError, NotFoundError } from "@/services/error_service";
import {
  CustomChairOrder,
  CustomUmbrellaOrder
} from "@/models/configurator/custom_umbrella";
import { Mobile } from "@/mixins/mobile";
import UIkit from "uikit";

@Component({
  components: {
    FabricFilter,
    Swatch
  }
})
export default class FabricSelector extends Mixins(Mobile) {
  @Prop({ default: FabricComponent.Main }) component!: FabricComponent;
  @Prop() model!: string;
  @Prop() swatch!: fabric.FabricSwatch;
  @Prop() canopy!: CustomUmbrellaOrder["canopy"];
  @Prop() mainFabric!: CustomChairOrder["mainFabric"];
  @Prop() chairBinding!: CustomChairOrder["bindingFabric"];
  @Prop({default: ProductType.Chair}) product!: ProductType;
  @Prop({ default: null }) index!: null | number;
  protected selected: fabric.FabricSwatch | null = null;
  protected fabricService = new FabricService();
  protected fabrics: fabric.FabricSwatch[] = [];
  protected searchTerm = "";
  protected fabricComponent = FabricComponent;
  protected solidsOnly = false;
  protected noStripes = false;
  protected gradeAOnly = false;
  protected filters: fabric.FabricFilter = {
    grade: "a",
    color: [],
    design: "",
    mfr: "",
    weight: ""
  };

  protected get filterMainFabricWeight(): string {
    let weight = '';
    if (this.product === 'umbrella' && this.canopy.mainFabric[0]?.weight) {
      weight =  this.canopy.mainFabric[0]?.weight
    } else if (this.product === 'chair') {      
      weight = '9';
    }
    return weight;
  }

  @Watch("swatch", { deep: true })
  protected onSwatchUpdate(): void {
    this.selected = { ...this.swatch };
    this.filters = this.getFilters(this.component!);
  }
  /** Switcher that executes logic based on the umbrella component we are selecting a fabric for
   * Watcher on this.component, which changes when user opens fabric selector modal
   */
  @Watch("component")
  protected onPropUpdate(): void {
    this.noStripes = false;
    this.solidsOnly = false;
    this.gradeAOnly = false;
    if (
      this.model.indexOf("-R") > -1 ||
      this.component === this.fabricComponent.VentTrim ||
      this.component === this.fabricComponent.MainTrim ||
      this.component === this.fabricComponent.MainTrimInner ||
      this.component === this.fabricComponent.ChairFabric 
    ) {
      this.noStripes = true;
    }
    this.filters = this.getFilters(this.component);
  }

  async mounted() {
    this.fabrics = await this.getFabrics();
  }

  protected getFilters(
    component: FabricComponent,
    fabric?: fabric.FabricSwatch
  ): fabric.FabricFilter {
    const swatch = fabric ? fabric : this.selected!;
    const filters = {
      grade: swatch && swatch.grade ? swatch.grade : "a",
      color: [],
      design: "",
      mfr: "",
      weight: swatch && swatch.weight ? swatch.weight : ""
    } as fabric.FabricFilter;
    if (
      component === FabricComponent.Binding ||
      component === FabricComponent.ChairBinding
    ) {
      this.setDesign("Solids");
      this.solidsOnly = true;
      this.noStripes = true;
    }
    if (component === FabricComponent.ChairFabric) {
      this.gradeAOnly = true;
    }
    if (component === FabricComponent.Pockets) {
      this.noStripes = true;
    }
    this.setGrade(swatch && swatch.grade ? swatch.grade : "a");
    return filters;
  }

  protected async getFabrics(): Promise<fabric.FabricSwatch[]> {
    const loader = this.$loading.show({
      isFullPage: false,
      container: this.$refs.spinnerContainerFabric
    });
    let fabricArray: fabric.FabricSwatch[] = [];
    try {
      let body;
      if (this.filters.grade) {
        body = { grade: this.filters.grade };
      }
      const res = await this.fabricService.getFabrics(body);
      fabricArray = res;
      this.$nextTick(() => {
        loader.hide();
      });
    } catch (err) {
      if (err instanceof NotFoundError) {
        NotFoundError.popup(err.message, err.statusCode);
      } else {
        APIError.popup(err.message, err.statusCode);
      }
      // loader.hide();
    }
    return fabricArray;
  }

  /** Getter for filtering fabrics with logic to account for all different available filters */
  protected get filteredFabrics(): fabric.FabricSwatch[] {
    let fabricArray: fabric.FabricSwatch[] = [...this.fabrics];
    fabricArray = fabricArray.filter( (swatch) => {
      if (swatch.inactive || swatch.discontinued) {
        return false;
      } else {
        return true;
      }
    });
    if (
      this.component === FabricComponent.Binding ||
      this.component === FabricComponent.ChairBinding
    ) {
      fabricArray = fabricArray.filter(swatch => {
        const pattern: fabric.FabricSwatch["pattern_group"] = swatch.pattern_group!;
        if (pattern.length > 0) {
          return pattern.includes("Solids");
        } else {
          return false;
        }
      });
    }
    if (
      this.component === FabricComponent.Pockets ||
      this.component === this.fabricComponent.VentTrim ||
      this.component === this.fabricComponent.MainTrim ||
      this.component === this.fabricComponent.MainTrimInner
    ) {
      fabricArray = fabricArray.filter(swatch => {
        const pattern: fabric.FabricSwatch["pattern_group"] = swatch.pattern_group!;
        if (pattern.length > 0) {
          return !pattern.includes("Stripes");
        } else {
          return false;
        }
      });
    }
    if (this.component === this.fabricComponent.ChairFabric) {
      this.setWeight(this.filterMainFabricWeight);
    }
    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase().trim();
      const matches = fabricArray.filter(swatch => {
        return swatch.mfr_code.toLowerCase().indexOf(term) !== -1;
      });
      const matchesName = fabricArray.filter(swatch => {
        return swatch.name.toLowerCase().indexOf(term) !== -1;
      });
      const matchesFFcode = fabricArray.filter(swatch => {
        if (swatch.frankford_code) {
          return swatch.frankford_code.toLowerCase().indexOf(term) !== -1;
        }
      });
      fabricArray = [...matches, ...matchesName, ...matchesFFcode];
    }
    if (this.filters.mfr) {
      fabricArray = fabricArray.filter(swatch => {
        return swatch.mfr_handle === this.filters.mfr;
      });
    }
    if (this.filters.design) {
      fabricArray = fabricArray.filter(swatch => {
        const pattern: fabric.FabricSwatch["pattern_group"] = swatch.pattern_group!;
        if (pattern.length > 0) {
          return pattern.includes(this.filters.design);
        } else {
          return false;
        }
      });
    }
    if (this.filters.color.length > 0) {
      const matches: fabric.FabricSwatch[] = [];
      fabricArray.map(swatch => {
        const colors: fabric.FabricSwatch["color_group"] = swatch.color_group!;
        if (colors.length > 0) {
          colors.map(color => {
            if (this.filters.color.includes(color)) {
              matches.push(swatch);
            }
          });
        }
      });
      fabricArray = matches;
    }
    if (this.noStripes) {
      fabricArray = fabricArray.filter(swatch => {
        const pattern: fabric.FabricSwatch["pattern_group"] = swatch.pattern_group!;
        if (pattern.length > 0 && pattern.includes("Stripes")) {
          return false;
        } else {
          return true;
        }
      });
    }
    if (this.filters.weight) {
      fabricArray = fabricArray.filter(swatch => {
        return swatch.weight === this.filters.weight;
      });
    }
    return fabricArray;
  }

  /** Switcher that communicates with umbrella modeler & saves choice to store based on user selections and specific umbrella component */
  protected async select(swatch: fabric.FabricSwatch): Promise<void> {
    if (this.component) {
      this.selected = swatch;
      switch (this.component) {
        case this.fabricComponent.Main:
        case this.fabricComponent.MainAlternating: {
          const fabric = [...this.canopy.mainFabric];
          if (this.index != null) {
            fabric[this.index] = this.selected;
          }
          this.updateFabricSwatch({ mainFabric: fabric });
          break;
        }
        case this.fabricComponent.TopVent: {
          const fabric = [...this.canopy.ventTopFabric];
          if (this.index != null) {
            fabric[this.index] = this.selected;
          }
          this.updateFabricSwatch({ ventTopFabric: fabric });
          break;
        }
        case this.fabricComponent.MiddleVent: {
          const fabric = [...this.canopy.ventMiddleFabric];
          if (this.index != null) {
            fabric[this.index] = this.selected;
          }
          this.updateFabricSwatch({ ventMiddleFabric: fabric });
          break;
        }
        case this.fabricComponent.Binding: {
          this.updateFabricSwatch({ bindingFabric: this.selected });
          break;
        }
        // case this.fabricComponent.Pockets: {
        //   this.updateFabricSwatch({ ribFabric: this.selected });
        //   break;
        // }
        case this.fabricComponent.MainTrim: {
          this.updateFabricSwatch({ mainTrimFabric: this.selected });
          break;
        }
        case this.fabricComponent.MainTrimInner: {
          this.updateFabricSwatch({ mainTrimFabricInner: this.selected });
          break;
        }
        case this.fabricComponent.VentTrim: {
          this.updateFabricSwatch({ ventTrimFabric: this.selected });
          break;
        }
        case this.fabricComponent.Valance: {
          const fabric = [...this.canopy.valanceFabric];
          if (this.index != null) {
            fabric[this.index] = this.selected;
          }
          this.updateFabricSwatch({ valanceFabric: fabric });
          break;
        }
        case this.fabricComponent.ChairFabric:
          this.updateChairFabricSwatch("mainFabric", this.selected);
          break;
        case this.fabricComponent.ChairBinding:
          this.updateChairFabricSwatch("bindingFabric", this.selected);
          break;
      }
    }
  }

  public updateFabricSwatch(newObj: any) {
    const newFabric = Object.assign({}, { ...this.canopy }, { ...newObj });
    this.$emit("update:canopy", newFabric);
  }

  public updateChairFabricSwatch(field: string, swatch: fabric.FabricSwatch) {
    this.$emit(`update:${field}`, swatch);
  }

  /** set####() methods below set filter values communicated from child FabricFilter.vue */
  protected async setGrade(value: fabric.FabricGrade): Promise<void> {
    this.filters.grade = value;
    this.fabrics = await this.getFabrics();
  }

  protected setColor(values: string[] | []): void {
    this.filters.color = values;
  }

  protected setDesign(value: string): void {
    this.filters.design = value;
  }

  protected setMfr(value: string): void {
    this.filters.mfr = value;
  }

  protected setWeight(value: string): void {
    this.filters.weight = value;
  }

  protected hideFabricSelector(): void {
    const el = document.getElementById("fabric-selector") as HTMLElement;
    UIkit.offcanvas(el).hide();
  }
}
